import { combineReducers } from 'redux';
import modal from './modals/reducer';
import product from './products/reducer';
import purchase from './purchase/reducer';
import collaborator from './collaborator/reducer';
import group from './group/reducer';
import assignor from './assignor/reducer';

const appReducer = combineReducers({
  modal,
  product,
  purchase,
  collaborator,
  group,
  assignor,
})

const rootReducer = (state: any, action: any) => {
  /*if (action.type === 'LOGOUT_USER' || action.type === 'LOGIN_USER') {
    return appReducer(undefined, action)
  }*/

  return appReducer(state, action)
}

export default rootReducer;
